const getInitialValues = form =>
  Object.keys(form)
    .reduce((acc, next) => ({
      ...acc,
      [form[next].name]: form[next].value
    }), {})

export default getInitialValues
